import Modal from "react-bootstrap/Modal";

export default function LoadingModalComponent(props) {
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="text-center">
          <i className="mdi mdi-dots-circle mdi-spin font-48 text-primary" />
        </div>
        <p className="text-center text-muted">Түр хүлээнэ үү...</p>
      </Modal.Body>
    </Modal>
  );
}
